import moment from "jalali-moment";

export function ConvertToPersianNumber(englishNumber: string) {
  const englishToPersianMap: { [key: string]: string } = {
    "0": "۰",
    "1": "۱",
    "2": "۲",
    "3": "۳",
    "4": "۴",
    "5": "۵",
    "6": "۶",
    "7": "۷",
    "8": "۸",
    "9": "۹"
  };

  let ConvertedNumber = "";
  for (const digit of englishNumber) {
    if (englishToPersianMap[digit]) {
      ConvertedNumber += englishToPersianMap[digit];
    } else {
      ConvertedNumber += digit;
    }
  }

  return ConvertedNumber;
}

export function ConvertToEnglishNumber(persianNumber: string) {
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  const englishNumber = persianNumber
    .split("")
    .map((char) => {
      const index = persianDigits.indexOf(char);
      return index !== -1 ? index.toString() : char;
    })
    .join("");

  return englishNumber;
}

export function convertDateFormat(dateString: string) {
  const dateParts = dateString.split("/");
  const convertedDate = dateParts.join("-");
  return convertedDate;
}

export function ConvertNumber(text: string, lang: string, separate?: boolean) {
  const validRegex = /[۰-۹0-9,]+/g;

  const filteredText = text.replace(/[^۰-۹0-9,]/g, "");

  if (validRegex.test(filteredText)) {
    let converted = filteredText;

    if (lang == "en") {
      converted = ConvertToEnglishNumber(filteredText);
    } else {
      converted = ConvertToPersianNumber(filteredText);
    }

    if (separate) {
      return formatPrice(converted);
    } else {
      return converted;
    }
  } else {
    return "";
  }
}

export function DeConvertNumber(text: string) {
  const filteredText = text.replace(/[^۰-۹0-9]/g, "");

  return ConvertToEnglishNumber(filteredText);
}

export function formatPrice(price: string): string {
  const data = price.replaceAll(",", "");

  const validRegex = /[۰-۹0-9,]+/g;

  if (!validRegex.test(data)) {
    return "";
  } else {
    const priceStr = data.toString().split("");

    let formattedPrice = "";

    for (let i = priceStr.length - 1, count = 0; i >= 0; i--) {
      formattedPrice = priceStr[i] + formattedPrice;
      count++;
      if (count === 3 && i !== 0) {
        formattedPrice = "," + formattedPrice;
        count = 0;
      }
    }

    return formattedPrice;
  }
}

export function ConvertDate(date: string, lang: string) {
  if (lang == "en") {
    return date.slice(0, 10);
  } else {
    return ConvertToPersianNumber(moment(
      ConvertToEnglishNumber(
        date?.slice(0, 10) + ""
      ),
      "YYYY/MM/DD"
    ).format("jYYYY-jMM-jDD"));
  }
}
